import { render, staticRenderFns } from "./MyStaffDetails.vue?vue&type=template&id=52d2fa89"
import script from "./MyStaffDetails.vue?vue&type=script&lang=js"
export * from "./MyStaffDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports